import { Stack } from '@mui/material';
import { ReactElement } from 'react';
import { CanAccess, Title } from 'react-admin';
import { useDefineAppLocation } from '@react-admin/ra-navigation';
import ActionLogsByUserWidget from './Widget';

export default function ActionLogsByUserPage(): ReactElement {
  useDefineAppLocation('action_logs.by_user');

  return (
    <>
      <Title title="Action Log By User" />
      <Stack spacing={3} sx={{ mt: 2, mb: 4 }}>
        <CanAccess resource="action_logs_by_users" action="list">
          <ActionLogsByUserWidget />
        </CanAccess>
      </Stack>
    </>
  );
}
